import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent, Grid, Chip, IconButton, Tooltip } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg } from "../../assets/svg/index.js";
import MainDatatable from "../../components/common/MainDatatable.jsx";
import * as RoleActions from "../../redux/actions/roleAction.js";

const RoleManagement = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { rolesData } = useSelector(state => state?.roleReducer);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);

    useEffect(() => {
        dispatch(RoleActions.getRoles());
    }, []);

    const handleView = (role) => {
        setSelectedRole(role);
        setViewModalOpen(true);
    };

    const roleColumns = [
        { name: 'S.No.', selector: (row, index) => index + 1, width: '80px' },
        { name: 'Role Name', selector: row => row?.name, sortable: true },
        { name: 'Description', selector: row => row?.description || '-', grow: 2 },
        { name: 'Modules', selector: row => row?.permissions?.filter(p => p.view || p.add || p.edit || p.delete).length || 0, width: '100px' },
        { name: 'Status', selector: row => (
            <Chip label={row?.isActive ? 'Active' : 'Inactive'} color={row?.isActive ? 'success' : 'default'} size="small" />
        ), width: '120px' },
        { name: 'Created', selector: row => new Date(row?.createdAt).toLocaleDateString('en-IN'), width: '120px' },
        {
            name: 'Action',
            cell: row => (
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    <Tooltip title="View Permissions">
                        <div style={{ cursor: "pointer", color: "#164E62", fontWeight: "bold", fontSize: "13px" }} onClick={() => handleView(row)}>View</div>
                    </Tooltip>
                    <div style={{ cursor: "pointer" }} onClick={() => navigate("/roles/edit-role", { state: { roleData: row } })}><EditSvg /></div>
                    <div style={{ cursor: "pointer" }} onClick={() => dispatch(RoleActions.deleteRole({ roleId: row?._id }))}><DeleteSvg /></div>
                </div>
            ),
            width: '200px',
        },
    ];

    return (
        <>
            <MainDatatable data={rolesData} columns={roleColumns} title={'Role Management'} url={'/roles/add-role'} />

            <Dialog open={viewModalOpen} maxWidth="md" fullWidth>
                <DialogContent>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                        <div style={{ fontSize: "20px", fontWeight: "600" }}>Role: {selectedRole?.name}</div>
                        <div style={{ cursor: "pointer" }} onClick={() => setViewModalOpen(false)}><CloseRounded /></div>
                    </div>
                    {selectedRole?.description && <p style={{ color: "#666", marginBottom: "15px" }}>{selectedRole.description}</p>}
                    
                    <div style={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#164E62", color: "#fff" }}>
                                    <th style={{ padding: "10px 15px", textAlign: "left" }}>Module</th>
                                    <th style={{ padding: "10px 15px", textAlign: "center" }}>View</th>
                                    <th style={{ padding: "10px 15px", textAlign: "center" }}>Add</th>
                                    <th style={{ padding: "10px 15px", textAlign: "center" }}>Edit</th>
                                    <th style={{ padding: "10px 15px", textAlign: "center" }}>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedRole?.permissions?.map((perm, idx) => (
                                    <tr key={idx} style={{ borderBottom: "1px solid #eee", backgroundColor: idx % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                                        <td style={{ padding: "8px 15px", fontWeight: "500" }}>{perm.module}</td>
                                        <td style={{ padding: "8px 15px", textAlign: "center" }}>{perm.view ? '\u2705' : '\u274C'}</td>
                                        <td style={{ padding: "8px 15px", textAlign: "center" }}>{perm.add ? '\u2705' : '\u274C'}</td>
                                        <td style={{ padding: "8px 15px", textAlign: "center" }}>{perm.edit ? '\u2705' : '\u274C'}</td>
                                        <td style={{ padding: "8px 15px", textAlign: "center" }}>{perm.delete ? '\u2705' : '\u274C'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default RoleManagement;
